<div class="containter">
    <p i18n >Unable to upload the file. Please select a file in "ged" format</p>
    <button i18n mat-dialog-close>Close</button>
</div>